import { useAuth0 } from "@auth0/auth0-react";

export const useRoles = () => {
  const { user, isAuthenticated } = useAuth0();
  const roles = user?.["https://dev.the-real-jade.com/claims/roles"] || [];
  return { roles, isAdmin: roles.includes("Admin"), isAuthenticated };
};
